import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

const rootReducer = combineReducers({
  Layout,
  Login,
  ForgetPassword,
  Profile,
})

export default rootReducer
